import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { BarGuageComponent } from './bar-guage.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule    
  ],
  declarations: [BarGuageComponent],
  exports: [BarGuageComponent],
})
export class BarGuageModule {}


